import { render, staticRenderFns } from "./TrainingRecordGrid.vue?vue&type=template&id=d4961eb4"
import script from "./TrainingRecordGrid.vue?vue&type=script&lang=js"
export * from "./TrainingRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports